import BaseModel from '../BaseModel';

export default class Referral extends BaseModel {
  static entity = 'referral';

  static primaryKey = 'id';

  static fields() {
    return {
      companiesCount: this.attr(null),
      companiesWithPaymentsCount: this.attr(null),
      moneyInfo: this.attr(null)
    };
  }

  static apiConfig = {
    actions: {
      async fetchReferralInfo() {
        return this.get(`referral/info`);
      },
      async fetchReferralDiscountInfo() {
        return this.get(`/referral/discount`)
      }
    },
  }
}
